import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

export interface DescriptionItem {
  label: ReactNode;
  value: ReactNode;
}

/** Read-only label/value pairs, e.g. on detail pages. Stacked on the phone. */
export function DescriptionList({
  items,
  className,
}: {
  items: readonly DescriptionItem[];
  className?: string;
}) {
  return (
    <dl className={cn('grid gap-x-6 gap-y-3 md:grid-cols-[minmax(8rem,auto)_1fr]', className)}>
      {items.map((item, index) => (
        <div key={index} className="contents">
          <dt className="text-fg-muted">{item.label}</dt>
          <dd className="-mt-2 min-w-0 text-fg md:mt-0">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
